export const CURRENCY_CONVERSION = 100;
